import React from 'react';
import Toggle from '../../common/Toggle';

class LabeledToggleElement extends React.Component {

    render() {
        const { icon, text, toggleChecked, toggleOnChange, spaceBetween, flexEnd, editMode } = this.props;

        let { flexSpaceBetween, flexCenter } = styles;
        if (spaceBetween) {
            flexSpaceBetween = { display: 'flex' };
            flexCenter = { ...flexCenter, marginRight: `${spaceBetween}px` }
        }

        if (flexEnd) {
            flexSpaceBetween = { ...flexSpaceBetween, justifyContent: "flex-end" };
        }

        return (
            <div style={flexSpaceBetween}>
                <div style={flexCenter}>
                    {icon}
                    <span style={icon ? { paddingLeft: '10px', fontWeight: 'bold' } : { fontWeight: 'bold' }}>
                        {text}
                    </span>
                </div>
                <div style={{ paddingTop: '5px' }}>
                    <Toggle
                        checked={toggleChecked}
                        disabled={editMode}
                        onChange={toggleOnChange}
                        offColor="#e5e5e5"
                        onColor="#f07df2"
                    />
                </div>
            </div>
        );
    }
}

export default LabeledToggleElement;

const styles = {
   
    flexSpaceBetween: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/LabeledToggleElement.js